const getParam = function(array, searchfirstword) {
  let result = "";
  array.forEach(function (elem) {
    if (elem.substring(0, searchfirstword.length) == searchfirstword) {
      result = elem.substring(searchfirstword.length);
    }
  });

  return result;
};

const getMarker = function (url) {
  const words = url.split("?")[0].split("/");
  // 施設位置の取得
  const data = getParam(words, "data=").split("!");

  const lat = getParam(data, "3d");
  const lng = getParam(data, "4d");
  const marker = {};
  let title = "";

  if (lat && lng) {
    marker.position = {
      lat: Number(lat),
      lng: Number(lng)
    };
  } else {
    let centerStr = getParam(url.split("/"), "@");
    centerStr = centerStr.substring(0, centerStr.length - 1);

    const values = centerStr.split(",");

    if (values.length == 3) {
      marker.position = {
        lat: Number(values[0]),
        lng: Number(values[1])
      };
    }
  }

  if(!marker.position) {
    console.log("warn: marker positon does not make!", url);
  }

  const i_place = words.indexOf("place");

  if (i_place != -1) {
    title = decodeURIComponent(words[i_place + 1]);
  }

  if (title) {
    marker.title = title;
  }
  return marker;
};

export default {
  convertMapLocations(locations) {
    return {
      markers: locations.map(function (item) {
        let marker = getMarker(item.data.map_url);
        marker.title = item.title.rendered;
        !marker.position && console.log('position null',marker.title);
        return marker;
      }),
      center: {
        lat: 33.9270445,
        lng: 134.4954201
      },
      scale: 12
    };
  },
  convertMapUrlToLatLang(url) {
    // GoogleMapのURLから緯度経度を取り出す

    // 中心位置の取得 - @から始まる文字列から推測
    let center = {};
    let scale = 15;
    let centerStr = getParam(url.split("/"), "@");
    centerStr = centerStr.substring(0, centerStr.length - 1);

    const values = centerStr.split(",");

    if (values.length == 3) {
      center = {
        lat: Number(values[0]),
        lng: Number(values[1])
      };
      scale = Number(values[2]);
    }

    return {
      markers: [getMarker(url)],
      center,
      scale
    };
  }
};
